import React from "react";

//Import external components
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Stack,
    TextField,
} from "@mui/material";
import { poster, putter } from "../../../functions/axios";
import { useMsal } from "@azure/msal-react";
import { Formik, Form, useFormik } from "formik";
import * as Yup from "yup";

export default function AlertDialogSlide(props) {
    const { instance } = useMsal();
    const userEmail = instance.getActiveAccount().username;
    const additionalInfo = props.additionalInfo;
    const edit = props.edit;

    const handleSave = (name, targetUrl) => {
        const baseURL = edit ? "edit/" : "create/";
        const bodyValues = {
            id: props.id,
            name: name,
            target_url: targetUrl,
        };
        if (edit) {
            putter(baseURL, bodyValues, props.updateQR);
        } else {
            bodyValues.created_by = userEmail;
            poster(baseURL, bodyValues, props.addNewQR);
        }
        resetValues();
        props.onClose();
    };
    const handleClose = () => {
        resetValues();
        props.onClose();
    };

    const resetValues = () => {
        formik.setValues({
            name: props.name,
            url: props.targetUrl,
        });
    };

    const pattern =
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g;
    const formik = useFormik({
        initialValues: {
            name: props.name,
            url: props.targetUrl,
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .min(6, "Name should be a minumum of 6 characters")
                .required("Name is required"),
            url: Yup.string()
                .matches(pattern, "URL is not valid")
                .required("URL is required"),
        }),
        onSubmit: (values) => {
            handleSave(values.name, values.url);
        },
        enableReinitialize: true,
    });

    return (
        <Dialog open={props.open} onClose={handleClose} maxWidth="lg">
            <DialogTitle variant="h5">{props.name || "New QR"}</DialogTitle>
            <Formik>
                <Form onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        <Typography paragraph>{additionalInfo}</Typography>
                        <Stack spacing={2}>
                            <TextField
                            fullWidth
                                // component={TextField}
                                label="Name"
                                name="name"
                                id="name"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.name &&
                                    Boolean(formik.errors.name)
                                }
                                helperText={
                                    formik.touched.name && formik.errors.name
                                }
                            />
                            <TextField
                                sx={{minWidth: "500px"}}
                                multiline
                                fullWidth
                                label="Target URL"
                                name="url"
                                id="url"
                                value={formik.values.url}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.url &&
                                    Boolean(formik.errors.url)
                                }
                                helperText={
                                    formik.touched.url && formik.errors.url
                                }
                            />
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" disabled={!formik.isValid}>
                            Save
                        </Button>
                    </DialogActions>
                </Form>
            </Formik>
        </Dialog>
    );
}
